import { Checkbox, FormControl, FormControlLabel, Grid } from '@mui/material';
import { StyledFormLabel } from 'components/atoms';
import {
  CheckboxFieldProps,
  withGridItemCSS,
  withWrapperCSS,
} from 'components/organisms/forms/form-builder/types';
import { noop } from 'lodash';
import React, { FC, useState } from 'react';

export const CheckboxField: FC<CheckboxFieldProps & withGridItemCSS & withWrapperCSS> = ({
  checkboxLabel,
  defaultChecked = false,
  disabled = false,
  fieldKey,
  gridItemCss,
  initValue = false,
  label = '',
  onChange = noop,
  labelCss,
  required = false,
  wrapperCss,
  xs = 12,
}) => {
  const [value, setValue] = useState(initValue || defaultChecked);

  function onFieldChange(checked: boolean) {
    onChange(checked, fieldKey);
    setValue(checked);
  }

  return (
    <Grid item xs={xs} style={gridItemCss}>
      <FormControl
        required={required}
        style={{ width: '100%', ...wrapperCss }}
        disabled={disabled}
      >
        <StyledFormLabel style={labelCss}>
          {label} {required ? '*' : null}
        </StyledFormLabel>
        <FormControlLabel
          control={<Checkbox checked={value} value={value} disabled={disabled} />}
          label={checkboxLabel}
          onChange={(_event, checked) => onFieldChange(checked)}
        />
      </FormControl>
    </Grid>
  );
};
